class WindowsManager {
  constructor() {
    this._LOCALSTORAGE_TIMESTAMP_KEY = 'WINDOW_VALIDATION_TIMESTAMP'
    this._LOCALSTORAGE_KEY = 'LIVE_WINDOW'
  }
  getWindowFromLocalStorage(wId) {
    let item = localStorage.getItem(this._LOCALSTORAGE_KEY + '_' + wId)
    return item ? JSON.parse(item) : null
  }
  setWindowToLocalStorage(window, wId) {
    localStorage.setItem(this._LOCALSTORAGE_KEY + '_' + wId, window)
  }
  removeWindowFromLocalStorage(wId) {
    localStorage.removeItem(this._LOCALSTORAGE_KEY + '_' + wId)
  }
  setTimestampToLocalStorage(timestamp) {
    localStorage.setItem(this._LOCALSTORAGE_TIMESTAMP_KEY, timestamp)
  }
  getTimestampFromLocalStorage() {
    return localStorage.getItem(this._LOCALSTORAGE_TIMESTAMP_KEY)
  }
  setOnBeforeWindowsCloseEvent(wId) {
    window.onbeforeunload = (event) => {
      this.removeWindowFromLocalStorage(wId)
      this.setTimestampToLocalStorage(Date.now())

      if (process.env.NODE_ENV === 'production' && !window.bypassCloseConfirmation) { // only add before reload listener on production      
        var confirmationMessage = "آیا از بسته شدن مرورگر مطمئن هستید؟";
        (event || window.event).returnValue = confirmationMessage //Gecko + IE
        return confirmationMessage
      }
      return void(0)
    }
  }
  initWindowsManager(wId) {
    return new Promise((resolve, reject) => {

      this.setOnBeforeWindowsCloseEvent(wId)

      this.setLiveKey()

      this.makeAliveWindowLocalStorage(wId)

      window.addEventListener('storage', (e) => {
        if (e.key == "live-key") {
          // Listen if anybody else is opening the app!
          this.makeAliveWindowLocalStorage(wId)
        }
      }, false)

      this.redirectToLoginIfRequired(resolve)
    })
  }
  redirectToLoginIfRequired(resolve) {
    const getWindowKeyItems = () => {
      let keys = []
      for (var i = 0, len = localStorage.length; i < len; ++i) {
        let key = localStorage.key(i)
        if (key.indexOf(this._LOCALSTORAGE_KEY) > -1)
          keys.push(key)
      }
      return keys
    }
    setTimeout(() => {
      let liveKey = localStorage.getItem('live-key')
      let windowKeys = getWindowKeyItems()
      for (var key of windowKeys) {
        let item = JSON.parse(localStorage.getItem(key))
        if (item.liveKey != liveKey)
          localStorage.removeItem(key)
      }
      windowKeys = getWindowKeyItems()
      let lastTimestamp = this.getTimestampFromLocalStorage()
      if (windowKeys.length <= 1 && (!lastTimestamp || (Date.now() / 1000) - (lastTimestamp / 1000) > 60)) {
        if (localStorage.getItem('nikan-user'))
          store.dispatch('useraccount/clearUser')
      }
      resolve()
    }, 2000)
  }
  makeAliveWindowLocalStorage(wId) {
    let liveKey = localStorage.getItem('live-key')
    var win = this.getWindowFromLocalStorage(wId)
    if (win) {
      win.liveKey = liveKey
    } else {
      win = {
        liveKey: liveKey
      }
    }
    this.setWindowToLocalStorage(JSON.stringify(win), wId)
  }
  setLiveKey() {
    localStorage.setItem('live-key', Date.now().toString())
    return localStorage.getItem('live-key')
  }
}

import store from '../store'

const windowsManager = new WindowsManager()
export default windowsManager